import trim from "lodash/trim";
import { IssueAttributes, IssueCustomAttribute } from "@adsk/acc-issues-types";
import mapValues from "lodash/mapValues";
import type {
  CustomAttributesInForm,
  IssueFormAttributes,
} from "@adsk/acc-issues-core/utils/types/Issue";

const TEXT_ATTRIBUTES = [
  "title",
  "locationDetails",
  "description",
] as (keyof IssueFormAttributes)[];

export const convertCustomAttrObjToArray = (
  customAttrObj: CustomAttributesInForm
): IssueCustomAttribute[] => {
  return Object.entries(customAttrObj).map(
    ([attributeDefinitionId, value]: [string, string | number | boolean]) => ({
      attributeDefinitionId,
      value: typeof value === "string" ? trim(value as string) : value,
    })
  );
};

export const sanitizeIssueAttributeMap = (
  inputIssueData: Partial<IssueFormAttributes>
): Partial<IssueAttributes> => {
  return mapValues(
    inputIssueData,
    (value: any, key: keyof IssueFormAttributes) => {
      if (TEXT_ATTRIBUTES.includes(key)) {
        if (!value) {
          return "";
        }
        return trim(value as string);
      }
      if (key === "customAttributes") {
        return convertCustomAttrObjToArray(value);
      }
      return value;
    }
  );
};
